<template>
  <div class="login-root">
    <div class="login-left">
      <div class="login-left-inner">
        <div class="div-margin-form">
          <div class="div-logo text-center">
            <img src="https://espaco.blob.core.windows.net/nixloc-imagens/nixloc.svg" alt="Nixloc" />
          </div>

          <br />

          <Login v-if="!forgotPassword" />
          <ForgotPassword v-else />

          <div v-if="!forgotPassword" class="text-center div-forgot-password" @click="forgotPassword = true">
            Esqueceu a senha?
          </div>

          <div v-else class="text-center div-forgot-password" @click="back">
            Voltar para o login
          </div>
        </div>
      </div>
    </div>

    <div class="login-right">
      <div class="login-img-wrap">
        <div class="login-img-bg" :style="bgStyle"></div>
        <div class="login-img-overlay"></div>
        <div class="login-img-center">
          <img class="login-img-foreground" alt="Imagem de login" :src="selectedImage" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Login from '../../../components/modules/adm/login/Login.vue'
import ForgotPassword from '../../../components/modules/adm/login/ForgotPassword.vue'

export default {
  name: 'LoginView',
  components: { Login, ForgotPassword },
  data() {
    return {
      forgotPassword: false,
      images: [/*'https://conteudo.nixloc.com.br/wp-content/uploads/2026/01/capa_evento3.webp',*/
        'https://conteudo.nixloc.com.br/wp-content/uploads/2026/01/capa_eventonoite.webp',
        'https://conteudo.nixloc.com.br/wp-content/uploads/2026/01/capa-doestoque.webp',
        'https://conteudo.nixloc.com.br/wp-content/uploads/2026/01/capa_assinatura.webp',
        'https://conteudo.nixloc.com.br/wp-content/uploads/2026/01/capa_dashboardpc.webp',],
      selectedImage: '',
    }
  },
  computed: {
    bgStyle() {
      return {
        backgroundImage: this.selectedImage ? "url('" + this.selectedImage + "')" : 'none',
      }
    },
  },
  mounted() {
    this.pickRandomImage()
  },
  methods: {
    back() {
      this.forgotPassword = false
    },
    pickRandomImage() {
      var index = Math.floor(Math.random() * this.images.length)
      this.selectedImage = this.images[index]
    },
  },
}
</script>

<style scoped>
.login-root {
  min-height: 100vh;
  height: 100vh;
  display: flex;
  overflow: hidden;
}

.login-left {
  width: 520px;
  max-width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 48px;
  height: 100vh;
}

.login-left-inner {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.login-right {
  flex: 1;
  background: #0b1220;
  min-width: 0;
  height: 100vh;
}

.login-img-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #0b1220;
}


.login-img-bg {
  position: absolute;
  inset: -20px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  filter: blur(18px);
  transform: scale(1.08);
  z-index: 0;
}


.login-img-overlay {
  position: absolute;
  inset: 0;
  background: rgba(11, 18, 32, 0.55);
  z-index: 1;
}

.login-img-center {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-img-foreground {
  width: 1400px;
  max-width: 100%;
  height: auto;
  max-height: 100%;
  display: block;
}

.div-forgot-password {
  margin-top: 15px;
  margin-bottom: 5px;
  cursor: pointer;
  color: #4680a5;
}

@media (max-width: 920px) {
  .login-left {
    width: 100%;
    padding: 28px 22px;
  }

  .login-right {
    display: none;
  }
}
</style>
